import TabBitacora from '../components/Tabs/TabBitacora';
import TabConsultas from '../components/Tabs/TabConsultas';
import TabPaciente from '../components/Tabs/TabPaciente';

export const TABS_CONFIG = [
    {
        id: 'paciente',
        name: 'Paciente',
        component: <TabPaciente />
    },
    {
        id: 'consultas',
        name: 'Consultas',
        component: <TabConsultas />
    },
    {
        id: 'bitacora',
        name: 'Bitácora',
        component: <TabBitacora />
    }
];

export const TAB_IDS = {
    PACIENTE: 'paciente',
    CONSULTAS: 'consultas',
    BITACORA: 'bitacora'
};